import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Facebook, Youtube, MapPin, Phone, Mail, Heart } from 'lucide-react';
import { FOOTER_LINKS, CONTACT_PHONE, CONTACT_EMAIL } from '../mock';
import { useLanguage } from '../i18n/LanguageContext';
import { useDonate } from '../donate/DonateContext';

const Footer = () => {
  const { t } = useLanguage();
  const { openDonate } = useDonate();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e, link) => {
    e.preventDefault();
    if (link.type === 'route') {
      navigate(link.href);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const tEl = document.getElementById(link.scrollId || link.id);
        if (tEl) tEl.scrollIntoView({ behavior: 'smooth' });
      }, 80);
    } else {
      const tEl = document.getElementById(link.scrollId || link.id);
      if (tEl) tEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="jbss-footer">
      <div className="jbss-container">
        <div className="jbss-footer-grid">
          <div className="jbss-footer-col">
            <div className="jbss-brand jbss-brand-footer">
              <span className="jbss-logo-slogan" aria-label="Educate, Organize and Agitate">
                <span>Educate</span>
                <span>Organize</span>
                <span>Agitate</span>
              </span>
              <span className="jbss-brand-text">
                <span className="jbss-brand-name" data-testid="footer-brand-name">{t('brand.name')} {t('brand.registered')}</span>
                <span className="jbss-brand-tag">{t('brand.tagline')}</span>
                <span className="jbss-brand-reg" data-testid="footer-reg-no">{t('brand.regNo')}</span>
              </span>
            </div>
            <p className="jbss-footer-about">{t('footer.about')}</p>
            <div className="jbss-socials">
              <a href="#" aria-label="Facebook" className="jbss-social"><Facebook size={16} /></a>
              <a href="#" aria-label="Youtube" className="jbss-social"><Youtube size={16} /></a>
            </div>
          </div>

          <div className="jbss-footer-col">
            <h4 className="jbss-footer-heading">{t('footer.quickLinks')}</h4>
            <ul className="jbss-footer-links">
              {FOOTER_LINKS.map((l) => (
                <li key={l.id}>
                  <a href={l.href} onClick={(e) => handleClick(e, l)}>{t(l.tKey)}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="jbss-footer-col">
            <h4 className="jbss-footer-heading">{t('footer.contact')}</h4>
            <ul className="jbss-footer-contact">
              <li><MapPin size={14} /><span>{t('footer.address')}</span></li>
              <li><Phone size={14} /><span>{CONTACT_PHONE}</span></li>
              <li><Mail size={14} /><span>{CONTACT_EMAIL}</span></li>
            </ul>
            <button className="jbss-btn jbss-btn-gold jbss-footer-donate" onClick={openDonate} data-testid="footer-donate">
              <Heart size={16} fill="currentColor" />
              <span>{t('nav.donate')}</span>
            </button>
          </div>
        </div>

        <div className="jbss-footer-bottom">
          <span>{t('footer.copyright')}</span>
          <span>{t('footer.tagline')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
